import { lazy } from 'react';
export default lazy(() => import('../games/GamesApp'));
